import { useIntl } from 'react-intl';

import { PointsStrategy, RandomLoyaltySegment, RandomLoyaltySegmentAwardType } from '../../../graphql/types.generated';
import { messagesSpinToWin } from './messages.spin-to-win';
import { IPointsChangeProps, PointsChange } from '../../../components/PointsChange/PointsChange';
import { PrizeIcon } from './prizeIcon';

export type SpinToWinWheelSectorContentProps = {
  pointsStrategy: PointsStrategy;
  sector: RandomLoyaltySegment;
  index: number;
};

export const SpinToWinWheelSectorContent = ({ pointsStrategy, sector, index }: SpinToWinWheelSectorContentProps) => {
  const intl = useIntl();

  if (sector.awardType === RandomLoyaltySegmentAwardType.TryAgain) {
    return intl.formatMessage(messagesSpinToWin['spinToWinGame:wheel-spin']);
  }
  if (sector.awardType === RandomLoyaltySegmentAwardType.NoAward) {
    return intl.formatMessage(messagesSpinToWin['spinToWinGame:wheel-no-lock']);
  }
  if (sector.awardType === RandomLoyaltySegmentAwardType.Points && sector.awardPoints?.points) {
    return (
      <PointsChange
        points={sector.awardPoints.points}
        iconSize="md"
        pointsStrategy={pointsStrategy as IPointsChangeProps['pointsStrategy']}
      />
    );
  }
  return <PrizeIcon fontSize="large" sx={{ transform: 'rotate(90deg)' }} />;
};
